import React, { useEffect } from "react";
import "./AdminDashboard.css";

const ADMIN_APP_URL = process.env.REACT_APP_ADMIN_URL || "https://benzies.brainfostertest.com/admin";

function AdminDashboard() {
  useEffect(() => {
    window.location.replace(ADMIN_APP_URL);
  }, []);

  return <main className="app-loading">Opening admin panel...</main>;
}

export default AdminDashboard;
